module.exports = __webpack_public_path__ + "img/closed_frame.a6c9241d.png";